module.exports = __webpack_public_path__ + "img/student-logo.69e8a3fd.png";